import { formatRupeeLabel } from '../../../../../display-values/lumpsumPlanAmount'
import type { LumpsumAllocationInvalidatedRecommendation } from '../../../../api/allocation.types'
import { LumpsumRecommendationActionType } from '../../../../api/common.types'
import type { PlanInvalidatedSubsectionKey } from '../../../../api/types'
import { PlansFundCard } from '../../../lumpsum-ui-components/PlansFundCard'
import { buildAllocationBuyInsights } from './AllocationBuyFundCard'
import { buildAllocationSellInsights } from './AllocationSellFundCard'
import { buildAllocationUnderReviewInsights } from './AllocationUnderReviewFundCard'

type AllocationInvalidatedFundCardProps = {
  recommendation: LumpsumAllocationInvalidatedRecommendation
  subsectionKey: PlanInvalidatedSubsectionKey
  categoryName: string
  showBottomDivider?: boolean
}

export function AllocationInvalidatedFundCard({
  recommendation,
  subsectionKey,
  categoryName,
  showBottomDivider = true
}: AllocationInvalidatedFundCardProps) {
  const isin = recommendation?.isin ?? ''
  const currentValue = recommendation?.currentValue ?? 0

  return (
    <PlansFundCard
      fund={{
        isin,
        logoUrl: recommendation?.mfLogoUrl ?? '',
        title: recommendation?.fundName ?? '',
        fundNature: recommendation?.fundNature ?? '',
        category: recommendation?.fundCategory ?? '',
        purchaseMode: recommendation?.purchaseMode ?? ''
      }}
      topRight={
        <div className="text-right shrink-0 -mt-[1px] text-[13px] font-[500] text-[#232323]">
          {formatRupeeLabel({ rawAmount: currentValue })}
        </div>
      }
      status={{
        rank: recommendation?.powerRank ?? 0,
        rating: recommendation?.powerRating ?? ''
      }}
      recommendationStatus={recommendation?.recommendationStatus}
      recommendationStatusDisplayText={recommendation?.recommendationStatusDisplayText}
      insights={getAllocationInvalidatedInsights(recommendation, subsectionKey, categoryName)}
      supportingText={recommendation?.recommendationStatusDisplayText ?? ''}
      showBottomDivider={showBottomDivider}
    />
  )
}

function getAllocationInvalidatedInsights(
  recommendation: LumpsumAllocationInvalidatedRecommendation,
  subsectionKey: PlanInvalidatedSubsectionKey,
  categoryName: string
) {
  if (subsectionKey === 'buy') {
    return buildAllocationBuyInsights(recommendation, categoryName)
  }

  if (subsectionKey === 'sell') {
    return buildAllocationSellInsights(recommendation, categoryName)
  }

  if (subsectionKey === 'underReview') {
    return buildAllocationUnderReviewInsights(recommendation, categoryName)
  }

  if (recommendation?.actionType === LumpsumRecommendationActionType.BUY) {
    return buildAllocationBuyInsights(recommendation, categoryName)
  }

  return buildAllocationSellInsights(recommendation, categoryName)
}
